/**
 * Nome do produto, como aparece para as pessoas (título da aba, entrada, aviso de mensagem nova).
 * Fica num lugar só: trocar o nome é mudar esta linha (e o `<title>` de `index.html`, que o
 * navegador lê antes de qualquer código e por isso não pode importar daqui; um teste confere os dois).
 */
export const APP_NAME = 'CladvApp';
